import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface SuperAdmin {
  id: string
  email: string
  name: string
  role: string
}

interface NexusState {
  token: string | null
  admin: SuperAdmin | null
  isAuthenticated: boolean
  setAuth: (token: string, admin: SuperAdmin) => void
  logout: () => void
}

export const useNexusStore = create<NexusState>()(
  persist(
    (set) => ({
      token: null,
      admin: null,
      isAuthenticated: false,
      setAuth: (token, admin) => set({ token, admin, isAuthenticated: true }),
      logout: () => set({ token: null, admin: null, isAuthenticated: false }),
    }),
    { name: 'nexus-auth' }
  )
)
